module.exports = __webpack_public_path__ + "static/media/thermometer.310b6053.svg";